module.exports = __webpack_public_path__ + "img/6X4_212.2d5d54df.png";